import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="rule-group-fields"
export default class extends Controller {
  static targets = ["ruleTypeSelect"];

  connect() {
    this.element.closest("div.list-group").addEventListener("nested-form:remove", this.ruleTypeSelectTargetDisconnected.bind(this));
  }

  ruleTypeSelectTargetConnected(target) {
    target.addEventListener(
      "tom-select:ready",
      () => {
        this.disableUsedRuleTypeOptions();
      },
      { once: true }
    );
  }

  ruleTypeSelectTargetDisconnected() {
    this.disableUsedRuleTypeOptions();
  }

  ruleTypeSelected() {
    this.disableUsedRuleTypeOptions();
  }

  disableUsedRuleTypeOptions() {
    const ruleTypesToDisable = this.getRuleTypesToDisable();

    if (this.ruleTypeSelectTargets.length === 1) {
      this.ruleTypeSelectTargets.forEach((ruleTypeSelect) => {
        const ruleTypeTomSelect = ruleTypeSelect.tomselect;

        Object.keys(ruleTypeTomSelect.options).forEach((optionValue) => {
          ruleTypeTomSelect.options[optionValue].disabled = ruleTypeTomSelect.options[optionValue].type == "disabled";
          ruleTypeTomSelect.updateOption(optionValue, ruleTypeTomSelect.options[optionValue]);
        });
      });

      return;
    }

    this.ruleTypeSelectTargets.forEach((ruleTypeSelect) => {
      const ruleTypeTomSelect = ruleTypeSelect.tomselect;

      Object.keys(ruleTypeTomSelect.options).forEach((optionValue) => {
        ruleTypeTomSelect.options[optionValue].disabled = ruleTypeTomSelect.options[optionValue].type == "disabled";
        ruleTypeTomSelect.updateOption(optionValue, ruleTypeTomSelect.options[optionValue]);
      });

      // Disable used options
      ruleTypesToDisable.forEach((usedRuleType) => {
        if (ruleTypeTomSelect.options[usedRuleType]) {
          ruleTypeTomSelect.options[usedRuleType].disabled = true;
          ruleTypeTomSelect.updateOption(usedRuleType, ruleTypeTomSelect.options[usedRuleType]);
        }
      });
      ruleTypeTomSelect.refreshOptions(false);
    });
  }

  getRuleTypesToDisable() {
    const ruleTypesToDisable = new Set();

    this.ruleTypeSelectTargets.forEach((ruleTypeSelect) => {
      if (ruleTypeSelect.value == "") return;

      ruleTypesToDisable.add(ruleTypeSelect.value);

      const ruleTypeTomSelect = ruleTypeSelect.tomselect;

      ruleTypeTomSelect.options[ruleTypeSelect.value].fields_to_disable.map((field) => {
        ruleTypesToDisable.add(field);
      });
    });

    return ruleTypesToDisable;
  }

  removeGroup({ params: { shouldRemove } }) {
    event.preventDefault();

    const item = event.target.closest(".js-rule-group-fields");

    if (shouldRemove) {
      item.remove();
      return;
    }

    const destroyInput = item.querySelector("input.js-destroy-rule-group-input");

    if (destroyInput) {
      destroyInput.value = "true";
    }

    item.style.display = "none";
  }
}
